import { useState } from "react";
import { Link2, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * Small copy-link icon button shown over product imagery.
 * Copies the backend /api/share URL (serves OG tags to scrapers,
 * redirects humans to the product page).
 */
export const CopyProductLinkButton = ({ productId, productName, className = "" }) => {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/product/${productId}`;
    const markCopied = () => {
      setCopied(true);
      toast.success("Product link copied to your clipboard.");
      setTimeout(() => setCopied(false), 2000);
    };
    try {
      await navigator.clipboard.writeText(url);
      markCopied();
    } catch {
      // Clipboard API missing or permission denied — legacy fallback.
      try {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        markCopied();
      } catch {
        window.prompt("Copy this link:", url);
      }
    }
  };

  return (
    <button
      type="button"
      data-testid={`copy-link-${productId}`}
      onClick={copyLink}
      aria-label={`Copy link to ${productName}`}
      title="Copy product link"
      className={`absolute bottom-3 left-3 h-8 w-8 inline-flex items-center justify-center rounded-full border border-white/25 bg-black/50 backdrop-blur-sm text-[#bfcde3] hover:text-white hover:border-white/60 hover:bg-black/70 transition-colors ${className}`}
    >
      {copied ? (
        <Check size={14} strokeWidth={2.5} className="text-[#7CE3A6]" />
      ) : (
        <Link2 size={14} strokeWidth={2.25} />
      )}
    </button>
  );
};
